import React from 'react';
function ArrowRightInCircleIcon({ fill = '#5D9CEC', width = 20, height = 20 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20">
            <path
                fill={fill}
                fillRule="nonzero"
                d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm1.146 4.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708l3.146-3.146H4.5a.5.5 0 1 1 0-1h9.792l-3.146-3.146a.5.5 0 0 1-.057-.638z"
            />
        </svg>
    );
}

export default ArrowRightInCircleIcon;
